import styled from 'styled-components';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  position: relative;
  cursor: pointer;
`;
